


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as VFooter from 'vuetify/es5/components/VFooter'
import * as VBtn from 'vuetify/es5/components/VBtn'
import * as VToolbar from 'vuetify/es5/components/VToolbar'

@Component({
  components: {
    ...VFooter,
    ...VBtn,
    ...VToolbar
  }
})
export default class App extends Vue {}
